import EditPlaceForm from "../../components/EditPlaceForm/EditPlaceForm"
import './PlaceEditPage.css' 


const PlaceEditPage = () => {

    return (
        <>
        <EditPlaceForm />
        </>
    )


}


export default PlaceEditPage